import moment from '@fr/moment';
import { renderTemplate } from '@fr/templating-utils';
import twbsPagination from '../vendor/jquery.twbsPagination';
import airlineFields from '../../../commons/js/custom_modules/airlineField/airlineFields';


$(function() {

  const $body = $('body'),
        $historicalDataElement = $('.js-historical-flightdata'),
        $noResultsFound = $('.js-no-results-found'),
        $badNetworkCall = $('.js-bad-network-call'),
        $searchFilterAirline = $('.search-filter__airline'),
        $searchFilterAirport = $('.search-filter__airport.tt-input'),
        $searchFilterDate = $('.search-filter__date input[name="flight_date_submit"]'),

        baseURL = 'https://flights.flightright.net/historical',

        // Any page containing data-attribute "data-hasHistorical" should be
        // allowed to load the historical flight data table.
        hasHistorical = $historicalDataElement.attr('data-hasHistorical'),

        // This refers to the data-attribute "data-status" which has values
        // "flight-delay" or "flight-cancellation".
        status = $historicalDataElement.attr('data-status'),
        locale = `${ $body.attr('data-language') }-${ $body.attr('data-country') }`;

 let airline = $historicalDataElement.attr('data-airline'),
     airport = $historicalDataElement.attr('data-airport'),
     size = $historicalDataElement.attr('data-size') | '10',
     date,
     paramMap = {
        status,
        airline,
        airport,
        size,
        date
      },
     queryString = buildQueryString(paramMap),
     url = `${ baseURL }${ queryString }`;

  if ( hasHistorical === "true"){

    // Hide already existing "No results found" and pagination nav element from DOM.
    $noResultsFound.hide();
    $badNetworkCall.hide();

    // Initialize airline autosuggest for Search filter.
    airlineFields.init();

    // Call Handlebars compiler.
    const incident = {
            'flight-delay': 2,
            'flight-cancellation': 3
          };

    let nextpage = '';

    // Get flight data with composed API URL and template.
    getFlightData();

    // On filter search with any or all parameters filled, create url with input
    // submitted by user.
    $('.search-filter__btn').on('click touchstart', function() {

      event.preventDefault();

      airline = $searchFilterAirline.attr('data-submit');
      airport = $searchFilterAirport.attr('data-submit');
      date = $searchFilterDate.val();
      size = $historicalDataElement.attr('data-size') | '10';
      paramMap = {
        airline,
        airport,
        date,
        size
      };

      // Create new url for call with search parameters. With new search results,
      // pagination is to be removed and added only if new results require.
      queryString = buildQueryString(paramMap);
      url = `${ baseURL }${ queryString }`;
      getFlightData();
    });
  }

  /**
   * Creates query string parameters to be appended to API URL.
   *
   * @param  {Object} paramMap Parameter map object consisting of status, airline,
   *                 airport iata, date and size.
   *
   */
  function buildQueryString(paramMap) {
    const reducer = (acc, curr) => {
      const pair = paramMap[curr] ? `${ curr }=${ paramMap[curr] }` : '';
      return acc ? `${ pair ? acc + `&` + pair : acc }` :  `${ pair ? acc + `?` + pair : acc }`;
    };
    return Object.keys(paramMap).reduce(reducer, '');
  }

  /**
   * Makes API call for data retrieval.
   *
   * @param  {Number} pageNum Pagenumber submitted to make call on pagination click.
   *
   */
  function getFlightData(pageNum) {

    // If it is a call from loading page, clicking on page number or search filter,
    // pagination does not need to be created.
    if (pageNum === undefined) {

      // If its a call from loading page or search filter, make loader appear
      // while GET request is being processed.
      url += `&page=0`;
      $('.js-flights-list').empty();
      $noResultsFound.hide();
      $('<div class="circle-spinner  iblock"></div>').appendTo('.loading-container');
      $('.loading-container').addClass('loading-contents');

    } else {
      // Append page number to API URL in order to get next results.
      url = url.substring(0, url.indexOf('&page'));
      url += `&page=${ pageNum }`;

    }

    // Make GET request with new API URL with appropriate parameters.
    $.ajax({
      url: url,
      headers: {
        // The backend accepts 'Accept-Language' in the form of 'de-DE' which
        // requires the locale to be defined as such.
        'Accept-Language': locale
      },
      type: 'GET',
      success: function(result) {

        // On successful response call, remove loader and bad network call message
        const $paginationWrapper = $('.js-pagination-wrapper');
        let html;
        $('.circle-spinner').remove();
        $('.loading-container').removeClass('loading-contents');
        $badNetworkCall.hide();
        if (result && result.totalPages) {

          // If response has more than 0 pages, check if pagination is required
          // and create the appropriate number of pages in pagination.

          $noResultsFound.hide();

          checkPagination($paginationWrapper, result.totalPages, pageNum, getFlightData);

          // Before displaying any data, format date to correct format for view.
          for (let i = 0; i < result.content.length; i++) {
            result.content[i].date = formatTime(result.content[i].date);
          }
          renderTemplate(result, 'js-flights-list__template', '.js-flights-list');

        } else {

          // If response is empty, display "No results found" message on screen
          // and remove any existing pagination.
          $noResultsFound.show();
          if ($paginationWrapper.length > 0){
            $paginationWrapper.remove();
          }
        }
      },
      error: function(jqxhr, textStatus = "no status", error = {}) {
        $('.circle-spinner').remove();
        $noResultsFound.hide();
        $badNetworkCall.show();
        console.error(`
          Request failed calling: ${ url } ,
          with respond: ${ jqxhr.responseText } , 
          with message: ${ textStatus } ,
          error: ${ JSON.stringify(error) } .
        `);
      }
    });
  }

  /**
   * Checks if pagination needs to be created with given results.
   *
   * @param {Object} $paginationWrapper Refers to the pagination wrapper dom element.
   * @param {Number} totalPages Total number of pages in results json from API call.
   * @param {Number} PageNum PageNum submitted to make call on pagination click.
   * @param {Object} onPageClickCallback Callback function to be called once the
   *                                     table has been loaded.
   *
   */
  function checkPagination($paginationWrapper, totalPages, pageNum, onPageClickCallback) {
    if (!pageNum){
      if (totalPages > 1){
        createPagination($paginationWrapper, totalPages, onPageClickCallback);
      } else {
        if ($paginationWrapper.length > 0) {
          $paginationWrapper.remove();
        }
      }
    }
  }

  /**
   * Creates pagination for results.
   *
   * @param {Object} $paginationWrapper Refers to the pagination wrapper dom element.
   * @param  {Number} totalPages Total number of pages in results json from API call.
   * @param {Object} onPageClickCallback Callback function to be called once the
   *                                     table has been loaded.
   *
   */
  function createPagination($paginationWrapper, totalPages, onPageClickCallback) {

    let visiblePages;

    visiblePages = totalPages < 5 ? totalPages : 5;

    renderTemplate({}, 'js-flights-list-pagination-template', '.js-flights-list-pagination');

    $('.js-pagination-page-number-list').twbsPagination({
      totalPages: totalPages,
      visiblePages: visiblePages,
      prev: '<span>Previous</span>',
      next: '<span>Next</span>',
      first: '<span>First</span>',
      last: '<span>Last</span>'
    }).on('page', function(event, page) {
      onPageClickCallback(page - 1);
    });

  }

  /**
   * Creates desired date format for given time
   *
   * @param  {String} time Time string passed by call result to be formated into
   *                       desired format.
   *
   */
   function formatTime(time) {

     let dateTimeValue = moment(time, 'YYYY-MM-DD HH:mm'),
         dateValue = '';

     if (dateTimeValue.isValid()) {
       dateValue = {
         'formatedDate': dateTimeValue.format('DD.MM.YYYY HH:mm'),
         'date': dateTimeValue.format('YYYY-MM-DD')
       };
       return dateValue;
     }
   }

});
